import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { togglePopup, toggleSpinner } from 'apps/auth/actions/appAction';
import { changeFormField, changeFormFieldValue } from 'apps/auth/actions/formAction';
import InputText from 'apps/auth/components/form-multi/InputText';
import { getField, validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { DELIVERY_HOME } from 'apps/auth/constants/Constants';
import { DELIVERY_METHOD, TO_PRV_ID } from 'apps/auth/constants/fieldsName';
import { AUTH_SEND_GET_FIELDS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';
import update from 'apps/auth/helpers/Immutability';

import InputDropBoxList from './InputDropBoxList';

const InputDropBox = (props) => {
    const [customValue, setValue] = useState(props.field?.value);
    const [listSelectedValue, setListSelectedValue] = useState('');

    const [isOpenedDropbox, toggleDropbox] = useState(false);
    const openDropbox = () => toggleDropbox(true);
    const closeDropbox = () => toggleDropbox(false);
    const isCountrySelectionElementType = props.field.selectionElementType === 'country';
    let isInitStateWithItems = false;

    const getParentField = () => {
        let parentField = {};
        if (props.field && props.field.parentField) {
            Object.values(props.fields).forEach((f) => {
                if (f.id === props.field.parentField) {
                    parentField = f;
                }
            });
        }
        return parentField;
    };

    const updateItems = () => {
        const parentField = getParentField();
        const fields = {
            [TO_PRV_ID]: getField(TO_PRV_ID, props.fields[TO_PRV_ID].value),
            parent_field_id: getField('parent_field_id', parentField.id),
            parent_field_value: getField('parent_field_value', parentField.value),
            field_id: getField('field_id', props.field.id),
        };
        props.toggleSpinner(true);
        apiFetchData(AUTH_SEND_GET_FIELDS, fields)
            .then((json) => {
                const newField = update(props.field, {
                    $auto: {
                        mandatory: { $set: json?.length > 0 },
                        value: { $set: '' },
                        items: { $set: json },
                    },
                });
                props.changeFormField(props.formName, newField).then(() => {
                    props.toggleSpinner(false);
                });
            })
            .catch((e) => {
                logWarn(e);
                props.toggleSpinner(false);
            });
    };

    const updateValueIfChangeItems = () => {
        if ((props.field.value || props.field.defaultValue) && Array.isArray(props.field.items)) {
            let item;
            if (!isCountrySelectionElementType) {
                item = props.field.value
                    ? props.field.items.find((i) => i.value === props.field.value)
                    : props.field.items.find((i) => i.value === props.field.defaultValue);
            } else if (isCountrySelectionElementType && props.field.value) {
                item = props.field.items.find((i) => i.value === props.field.value);
            }
            if (item) {
                selectItem(null, item);
            } else {
                props.changeFormFieldValue(props.formName, null, props.field.name);
                setValue('');
            }
        } else {
            setValue('');
            setListSelectedValue('');
        }
    };

    const updateCustomValue = (item) => {
        if (item && item.text !== customValue) {
            setValue(item.text);
        }
    };

    useEffect(() => {
        isInitStateWithItems = Array.isArray(props.field.items) && props.field.items.length > 0;
    }, []);

    useEffect(() => {
        if (Array.isArray(props.field?.items)) {
            const item = props.field.items.find((i) => i.value === props.field?.value);
            if (item) {
                updateCustomValue(item);
            } else {
                updateValueIfChangeItems();
            }
        }
    }, [props.field?.value]);

    useEffect(() => {
        if (!isInitStateWithItems && props.field && props.field.parentField && getParentField().value) {
            updateItems();
        }
    }, [getParentField().value]);

    useEffect(() => {
        if (props.field) {
            updateValueIfChangeItems();
        }
    }, [props.field ? props.field.items : false]);

    const selectItem = (e, item, dropboxIsOpen) => {
        if (e) {
            e.preventDefault();
            e.persist();
        }
        validationAndUpdateValue(props.formName, item.value, props.field, props.changeFormField).then(() => {
            Object.values(props.fields).forEach((f) => {
                if (
                    f?.showOnFieldSelectionName === props.field.name &&
                    'to_recipient_category_type' === f?.showOnFieldSelectionName &&
                    f?.showOnFieldSelectionValue !== item.value
                ) {
                    const newField = update(f, {
                        $auto: {
                            isError: { $set: false },
                        },
                    });
                    props.changeFormField(props.formName, newField);
                } else if (f?.showOnFieldSelectionName === props.field.name && f?.showOnFieldSelectionValue !== item.value) {
                    const newField = update(f, {
                        $auto: {
                            value: { $set: null },
                            isError: { $set: false },
                        },
                    });
                    props.changeFormField(props.formName, newField);
                }
            });
            setValue(item.text);
            setListSelectedValue(item.value);
            if (e && !dropboxIsOpen) {
                closeDropbox();
            }
            if (props.selectHandler) {
                props.selectHandler(item);
            }
        });
    };

    const focusHandler = (e) => {
        e.stopPropagation();
        openDropbox();
    };

    const showNotFound = props.fields[DELIVERY_METHOD] !== undefined && props.fields[DELIVERY_METHOD].value === DELIVERY_HOME;

    const notFoundForVietnam = showNotFound && props.vietnam;

    if (props.field && props.field.parentField && Array.isArray(props.field.items) && !props.field.items.length) {
        return false;
    } else {
        return (
            <>
                <InputText
                    onClick={(e) => {
                        e.stopPropagation();
                        openDropbox();
                    }}
                    validateOnBlur={false}
                    field={props.field}
                    customValue={customValue}
                    formName={props.formName}
                    autoFocus={props.focus}
                    onFocus={focusHandler}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    isNewInput
                    isPseudoSelect
                    isNativeReadOnly
                />
                {isOpenedDropbox && (
                    <InputDropBoxList
                        selectItem={selectItem}
                        searchPlaceholder={props.searchPlaceholder}
                        searchDropBoxEmpty={props.searchDropBoxEmpty}
                        items={props.field.items}
                        selectTitle={props.field.selectTitle}
                        selectSubTitle={props.field.selectSubTitle}
                        placeholder={props.field.placeholder}
                        groups={props.field.groups}
                        id={props.field.id}
                        name={props.field.name}
                        notFoundAddress={props.field.name === 'to_district' ? props.districtNotFound : props.provinceNotFound}
                        togglePopup={props.togglePopup}
                        showAddressNotFound={showNotFound}
                        addressNotFoundIcon={notFoundForVietnam ? 'retry' : undefined}
                        clickNotFoundBtn={() => {
                            if (notFoundForVietnam) {
                                window.history.back();
                            }
                        }}
                        onCloseIconClick={closeDropbox}
                        selectedValue={listSelectedValue}
                        isCountrySelectionElementType={isCountrySelectionElementType}
                        closeDropbox={closeDropbox}
                        dropdownModalOverflowHidden={props.dropdownModalOverflowHidden}
                        field={props.field}
                        formName={props.formName}
                        hasCountryItemPanel={props.hasCountryItemPanel}
                        clearFieldsOnCountrySelect={props.clearFieldsOnCountrySelect}
                    />
                )}
            </>
        );
    }
};

const mapStateToProps = ({ form, messages, extra }, ownProps) => ({
    vietnam: extra?.toCountry?.vietnam,
    fields: form[ownProps.formName].fields,
    searchPlaceholder: messages.jsMessages['site.field.search.placeholder'],
    searchDropBoxEmpty: messages.jsMessages['site.search.dropdox.empty'],
    districtNotFound: messages.pageMessages.districtNotFound,
    provinceNotFound: messages.pageMessages.provinceNotFound,
});

export default connect(mapStateToProps, {
    changeFormField,
    changeFormFieldValue,
    toggleSpinner,
    togglePopup,
})(InputDropBox);
